import * as React from "react"

import GridMasonry from "./GridMasonry"
import PlaceholderWidget from "./widgets/PlaceholderWidget"
import BookmarkWidget from "./widgets/BookmarkWidget"
import WorkspaceContentWidget from "../../workspacecoverpage/components/Content"
import WelcomePageContentWidget from "../../welcomepage/components/Workspaces"
import ShortcutWidget from "./widgets/ShortcutWidget"
import { Labels } from "../../../util/Translations"
import { Bookmark, IGridTile, IShortcut } from "../../../models"

interface Props {
    bookmarks: Record<string, Bookmark>
    isLoading: boolean
    shouldShowWorkspaceScreenLabel: boolean
    tiles: IGridTile[]
    shortcuts: Record<string, IShortcut>
}

export const GridComponent = ({
    bookmarks,
    isLoading,
    shouldShowWorkspaceScreenLabel,
    tiles,
    shortcuts,
}: Props): JSX.Element => {
    const { LoadMore, SearchWorkspaceContent, SearchWorkspace, Workspaces } =
        Labels

    return (
        <GridMasonry>
            {isLoading && <PlaceholderWidget />}
            {isLoading && <PlaceholderWidget />}
            {isLoading && <PlaceholderWidget />}

            {!isLoading &&
                tiles.map((tile, index) => {
                    // using index as key ensures that upon reordering the grid will be rerendered with the new order
                    if (
                        tile.type === "Bookmark" &&
                        !!bookmarks[tile.bookmarkId]
                    ) {
                        return (
                            <BookmarkWidget
                                bookmark={bookmarks[tile.bookmarkId]}
                                key={index}
                                shouldShowWorkspaceScreenLabel={
                                    shouldShowWorkspaceScreenLabel
                                }
                            />
                        )
                    } else if (
                        tile.type === "Shortcut" &&
                        !!shortcuts[tile.shortcutId]
                    ) {
                        return (
                            <ShortcutWidget
                                shortcut={shortcuts[tile.shortcutId]}
                                key={index}
                                shouldShowWorkspaceScreenLabel={
                                    shouldShowWorkspaceScreenLabel
                                }
                            />
                        )
                    } else if (tile.type === "WorkspaceContent") {
                        return (
                            <WorkspaceContentWidget
                                loadMoreLabel={LoadMore}
                                placeholderLabel={SearchWorkspaceContent}
                                width={2}
                                key={index}
                            />
                        )
                    } else if (tile.type === "WelcomePageContent") {
                        return (
                            <WelcomePageContentWidget
                                loadMoreLabel={LoadMore}
                                placeholderLabel={SearchWorkspace}
                                title={Workspaces}
                                width={2}
                                key={index}
                            />
                        )
                    }
                })}
        </GridMasonry>
    )
}

GridComponent.defaultProps = {
    shouldShowWorkspaceScreenLabel: true,
}

export default GridComponent
